(function resizeHandler(global) {
  'use strict';

  global.NewHomeSource = global.NewHomeSource || {};

  if (!global.NewHomeSource.FullImageViewer.Config) {
    return;
  }

  const previousResizeHandler = global.NewHomeSource.ResizeHandler;
  const filmStripContainer = global.NewHomeSource.FullImageViewer.Config.filmStrip;
  const fullImageViewerContainer = global.NewHomeSource.FullImageViewer.Config.fullImageViewer;
  const imagesContainer = global.document.querySelector(global
    .NewHomeSource.FullImageViewer.Config.queryImagesContainer);

  /**
   * @private
   * calculateArea: gets the width and height available to display the media.
   * @param {*} callback function to execute after the width and height has been found.
   */
  function calculateArea(callback) {
    const filmStripSize = filmStripContainer.getBoundingClientRect();
    const size = imagesContainer.getBoundingClientRect();
    const fullImageViewerSize = fullImageViewerContainer.getBoundingClientRect();
    const height = size.height + 1;
    const width = fullImageViewerSize.width - filmStripSize.width - 52;

    if (typeof callback === 'function') {
      callback({ width, height });
    }
  }

  /**
  * @constructs NewHomeSource.ResizeHandler
  */
  function ResizeHandler() {
  }

  /**
  * @public
  *
  * resize: Returns resized element according to images container.
  */
  ResizeHandler.calculate = function calculate(callback) {
    requestAnimationFrame(calculateArea.bind(this, callback));
  };

  /**
   * @public
   *
   * noConflict: Returns control of NewHomeSource.ResizeHandler to the previous script.
   */
  ResizeHandler.noConflict = function noConflict() {
    global.NewHomeSource.ResizeHandler = previousResizeHandler;
    return ResizeHandler;
  };

  global.NewHomeSource.ResizeHandler = ResizeHandler;
}(window));
